export const parsePatientResponse = (rawText = '') => {
    const segments = [];
    let displayText = '';

    // Supports:
    // [VERBAL]...[/VERBAL]
    // [NON-VERBAL display="..." tts="..."]...[/NON-VERBAL]
    // [NON-VERBAL display="..." tts="..."]  (no closing tag)
    const markerRegex = /\[VERBAL\]([\s\S]*?)\[\/VERBAL\]|\[NON-VERBAL(?:\s+([^\]]*))?\](?:([\s\S]*?)\[\/NON-VERBAL\])?/gi;

    let match;
    let lastIndex = 0;

    while ((match = markerRegex.exec(rawText)) !== null) {
        if (match.index > lastIndex) {
            const untagged = rawText.slice(lastIndex, match.index).trim();
            if (untagged) {
                segments.push({ type: 'verbal', display: untagged, tts: untagged });
                displayText += `${untagged} `;
            }
        }

        if (match[1] !== undefined) {
            const verbal = match[1].trim();
            if (verbal) {
                segments.push({ type: 'verbal', display: verbal, tts: verbal });
                displayText += `${verbal} `;
            }
        } else {
            const attrs = match[2] || '';
            const body = (match[3] || '').trim();
            const displayAttr = /display="([^"]*?)"/i.exec(attrs)?.[1]?.trim() || body;
            const ttsAttr = /tts="([^"]*?)"/i.exec(attrs)?.[1]?.trim() || displayAttr;

            if (displayAttr || ttsAttr) {
                segments.push({
                    type: 'nonverbal',
                    display: displayAttr,
                    tts: ttsAttr
                });
                if (displayAttr) {
                    displayText += `${displayAttr} `;
                }
            }
        }

        lastIndex = markerRegex.lastIndex;
    }

    if (lastIndex < rawText.length) {
        const trailing = rawText.slice(lastIndex).trim();
        if (trailing) {
            segments.push({ type: 'verbal', display: trailing, tts: trailing });
            displayText += `${trailing} `;
        }
    }

    if (segments.length === 0 && rawText.trim()) {
        const cleanText = rawText.trim();
        segments.push({ type: 'verbal', display: cleanText, tts: cleanText });
        return { segments, displayText: cleanText };
    }

    return {
        segments,
        displayText: displayText.trim()
    };
};

export const toConciseNonVerbal = (text, maxLen = 90) => {
    const normalized = (text || '').replace(/\s+/g, ' ').trim();
    if (!normalized) return '';
    if (normalized.length <= maxLen) return normalized;
    return `${normalized.slice(0, maxLen - 3).trimEnd()}...`;
};
